import { makeAutoObservable } from "mobx";

const MAX_LOG_LINES_PER_SERVER = 1000;

export default class LogStore {
    constructor() {
        this._log = {};
        this._pausedServers = {};

        makeAutoObservable(this);
    }

    setLog(storage) {
        const { log, data } = storage || {};

        if (typeof log === "undefined" || log === null || !Array.isArray(data)) {
            console.warn("Некорректные данные для setLog:", storage);
            return;
        }

        if (this.isPaused(log)) {
            return;
        }

        const current = this._log[log] || { log, data: [] };
        const nextData = current.data.concat(data).slice(-MAX_LOG_LINES_PER_SERVER);

        this._log = {
            ...this._log,
            [log]: {
                log,
                data: nextData,
            },
        };
    }

    replaceLog(storage) {
        const { log, data } = storage || {};

        if (typeof log === "undefined" || log === null || !Array.isArray(data)) {
            console.warn("Некорректные данные для replaceLog:", storage);
            return;
        }

        this._log = {
            ...this._log,
            [log]: {
                log,
                data: data.slice(-MAX_LOG_LINES_PER_SERVER),
            },
        };
    }

    clearLog(logId) {
        const nextLog = { ...this._log };
        delete nextLog[logId];
        this._log = nextLog;
    }


    setPaused(logId, value) {
        if (typeof logId === "undefined" || logId === null) {
            return;
        }

        this._pausedServers = {
            ...this._pausedServers,
            [Number(logId)]: Boolean(value),
        };
    }

    pauseLog(logId) {
        this.setPaused(logId, true);
    }

    resumeLog(logId) {
        this.setPaused(logId, false);
    }

    isPaused(logId) {
        return Boolean(this._pausedServers[Number(logId)]);
    }

    getStorageByLogId(logId) {
        return this._log[logId] || { log: logId, data: [] };
    }

    reset() {
        this._log = {};
        this._pausedServers = {};
    }

    get log() {
        return this._log;
    }
}
